import { Component, ViewChild } from '@angular/core';
import { NavParams, Slides } from 'ionic-angular';

@Component({

   selector: 'page-popover-days',
   templateUrl: 'popover-days.html'
})

export class PopoverDaysPage
{

   @ViewChild( 'integerSlide' ) integerSlide: Slides;
   @ViewChild( 'decimalSlide' ) decimalSlide: Slides;

   private integers = [];

   private startIdx = 0;
   private endIdx = 0;

   private initVal;
   private itemIdx;
   private itemObjIdx;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private params: NavParams )
   {

      this.startIdx = this.params.get( 'start' );
      this.endIdx = this.params.get( 'end' );
      this.initVal = this.params.get( 'init' );
      this.itemIdx = this.params.get( 'itemIdx' );
      this.itemObjIdx = this.params.get( 'itemObjIdx' );
      this.callback = this.params.get( 'callback' );

   }


   ngAfterViewInit()
   {
      this.integers[0] = '';
      for ( let i = this.startIdx; i <= this.endIdx + 2; i++ )
      {
         this.integers[ this.integers.length ] = ( i <= this.endIdx ) ? i : '';
      }
      this.integerSlide.initialSlide = this.integers.indexOf( this.initVal );

      /*
      let intObj = Math.floor( this.initVal );
      this.integerSlide.initialSlide = this.integers.indexOf( '' + intObj );
      let decimalObj = Math.round( this.initVal % 1 * 10 ) / 10;
      console.log( decimalObj );
      let modDecimalObj = ( decimalObj != 0 ) ? decimalObj.toString().substring( 1, 3 ) : '.0';
      this.decimalSlide.initialSlide = this.decimals.indexOf( '' + modDecimalObj );
      console.log( modDecimalObj );
      */

   }


   /** ----- UI Callbacks ----- **/

   onSlideChanged()
   {

      let integerIdx = ( this.integerSlide.getActiveIndex() > this.integers.length - 3 ) ? this.integers.length - 3 : this.integerSlide.getActiveIndex();
      console.log( 'slide change: ' + integerIdx );
      if ( this.callback != null )
      {
         if ( this.integers[ integerIdx ] != null )
         {
            this.callback( this.itemIdx, this.itemObjIdx, '' + this.integers[ integerIdx + 1] );
         }
      }

   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-days/popover-days.ts